import { render, staticRenderFns } from "./yujianfenzhenForm.vue?vue&type=template&id=0c063086&scoped=true&"
import script from "./yujianfenzhenForm.vue?vue&type=script&lang=js&"
export * from "./yujianfenzhenForm.vue?vue&type=script&lang=js&"
import style0 from "./yujianfenzhenForm.vue?vue&type=style&index=0&id=0c063086&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c063086",
  null
  
)

export default component.exports